import React, { Component } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore, combineReducers } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'

import './scss/style.css'
import '@fontsource/roboto'

import { Home, Login, Page404, Page500, Register } from './views';
import {reducer as contentReducer} from "./reducers/Content/reducer";
import {reducer as userReducer} from "./reducers/User/reducer";
import {keycloak as userMiddleware} from "./middleware/User/keycloak.js";
import {reducer as interactionReducer} from "./reducers/interaction/reducer";
import {reducer as simParamReducer} from "./reducers/SimulationParameters/reducer";
import {reducer as stlColumnReducer} from "./reducers/STL_Column/reducer";
import {reducer as ctColumnReducer} from "./reducers/CT_Column/reducer";



//-----------------------------------------------------------------



const initial_state = {};
const history = createBrowserHistory({basename :"/ctparams"});
var reducer = combineReducers({
                user: userReducer,
                interaction: interactionReducer,
                content:contentReducer,
                simParam: simParamReducer,
                stlColumn: stlColumnReducer,
                ctColumn: ctColumnReducer,
              });


const store = createStore(
  connectRouter(history)(reducer),
  initial_state,

  compose(
    applyMiddleware(
      userMiddleware,
      routerMiddleware(history),
    ),
  ),

);



//-----------------------------------------------------------------



class App extends Component {

  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Switch>

            <Route exact  path="/login" 
                          name="Login Page" 
                          component={Login} 
            />

            <Route exact  path="/register" 
                          name="Register Page" 
                          component={Register} 
            />

            <Route exact  path="/404" 
                          name="Page 404" 
                          component={Page404} 
            />

            <Route exact  path="/500" 
                          name="Page 500" 
                          component={Page500} 
            />

            <Route        path="/" 
                          name="Home" 
                          render={() => {
                            let state = store.getState();

                            if (!state.user.authenticated)  return (<Home dispatch={store.dispatch}/>);
                            else                            return (<Redirect to="/login"/>);
                          }} 
            />

          </Switch>
        </ConnectedRouter>
      </Provider>
    );
  }

}

export default App;
